// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  overflow-y: auto;
  background-color: #f9f9f9;
}

.message-bubble {
  max-width: 60%;
  padding: 8px 12px;
  border-radius: 12px;
  font-size: 14px;
  position: relative;
  color: #000;
}

.left {
  align-self: flex-start;
  background-color: #ffffff;
}

.right {
  align-self: flex-end;
  background-color: #007bff;
  color: #fff;
}

.message-user {
  font-weight: bold;
  margin-bottom: 4px;
}

.message-text {
  line-height: 1.4;
  margin-bottom: 4px;
}

/* Attachments */
.message-attachments {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.attachment-link {
  color: inherit;
  text-decoration: underline;
  font-size: 0.9rem;
}

.message-timestamp {
  font-size: 0.75rem;
  opacity: 0.7;
  margin-top: 4px;
  text-align: right; /* or left, if you prefer */
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/main/client-request/client-message.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;EACA,yBAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;AACF;;AAEA,gBAAA;AACA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,cAAA;EACA,0BAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA,EAAA,2BAAA;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
